<section class="header">
    <edge-global-header></edge-global-header>
  </section>
  
  <section class="hero">
    <edge-global-hero
      image="/assets/images/fitness/fitness-hero.jpg"
      logo="/assets/images/fitness/edge-fitness-logo-temp.png"
      [socialIcons]="socialIcons"
      [tagline]="tagline">
    </edge-global-hero>
  </section>
  
  <section class="content">
    <edge-fitness-content></edge-fitness-content>
  </section>
  
  <section class="app-downloads">
    <edge-global-app-downloads
      sport="Fitness"
      sportLinkApple="//apps.apple.com/us/app/goarmy-edge-fitness/id1404047056"
      sportLinkGoogle="//play.google.com/store/apps/details?id=sed.ags.USArmySports.fitness">
    </edge-global-app-downloads>
  </section>
  
  <section class="bottom">
    <edge-global-bottom></edge-global-bottom>
  </section>
  
  <section class="footer">
    <edge-global-footer></edge-global-footer>
  </section>
  